(function Module() {
	'use strict';
	module.exports = {
		array: require('./array'),
		images: require('./images'),
		lists: require('./lists'),
		masks: require('./masks'),
		maxlengths: require('./maxlengths'),
		number: require('./number'),
		object: require('./object'),
		patterns: require('./patterns'),
		string: require('./string')
	};
})();
